import React, {useEffect} from "react";
import {Link, useLocation} from "react-router-dom";
import SiteNav from "../components/site/SiteNav";

function Layout({className, children, tag: Tag = "div"}) {
    const {pathname} = useLocation();
    const showMobileCta = pathname !== "/contact";

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        window.scrollTo({top: 0, left: 0, behavior: "auto"});
    }, [pathname]);

    return (
        <Tag id="main_layout" className={className}>
            <SiteNav/>
            {children}
            {showMobileCta && (
                <Link className="modern-mobile-cta" to="/contact" aria-label="Hire Kevin J Nichols">
                    <span>Ready to Start?</span>
                    <strong>Hire</strong>
                </Link>
            )}
        </Tag>
    );
}

export default Layout;
